import { render, staticRenderFns } from "./ProductCardSTP.vue?vue&type=template&id=6cae259a&"
import script from "./ProductCardSTP.vue?vue&type=script&lang=js&"
export * from "./ProductCardSTP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports